<template>
    <div class="main">
        <transition name="bounce">
            <template v-if="scoreinfo.length!=0">
                <div class="detail" :style="{background:bgcolor}">
                    <div class="avatar">
                        <img :src="scoreinfo.avatar?scoreinfo.avatar:defaultAvatar" alt="">
                    </div>
                    <img src="@/images/checkin/score_header.png" alt="">
                    <div class="userinfo">
                        <div style="font-family: DISPLAY;">{{scoreinfo.number}}</div>
                        <div>{{scoreinfo.name}}</div>
                    </div>

                    <div style="margin-top:100px;">
                        <div class="score">
                            <span>{{hour}}</span>
                            <img src="@/images/checkin/maohao.png" alt="">
                            <span>{{minute}}</span>
                            <img src="@/images/checkin/maohao.png" alt="">
                            <span>{{second}}</span>
                        </div>
                        <div class="info">
                            {{scoreinfo.unit}} - {{scoreinfo.groupname}}
                        </div>
                    </div>
                </div>
            </template>
        </transition>
    </div>
</template>

<script>
    import { g100pscore } from "../../libs/api";
    import defaultavatar from '@/images/checkin/avatar.png'
    import moment from "moment";

    export default {
        data() {
            return {
                matchid:"",
                bgcolor: 'rgba(255,255,255,0)',
                hour: '00',
                minute: '00',
                second: '00',
                scoreinfo: [],
                defaultAvatar:""
            };
        },
        mounted() {
            this.defaultAvatar  =   defaultavatar;
            this.matchid = this.$route.params.matchid;
            this.$nextTick(() => {
                this.get_score_info();
            })

            setInterval(()=>{
                this.get_score_info();
            },5000)
        },
        methods: {
            get_score_info() {
                g100pscore({matchid:this.matchid}).then((res)=>{
                    if(res.status==200){
                        this.bgcolor = 'rgba(255,255,255,.95)'
                        this.scoreinfo  =   res.data;

                        let t = moment.duration(res.data.score);
                        this.hour =t.hours()>10?t.hours():"0"+t.hours();
                        this.minute =t.minutes()>10?t.minutes():"0"+t.minutes();
                        this.second =t.seconds()>10?t.seconds():"0"+t.seconds();
                    }


                })
            },
        }
    };
</script>


<style lang="less" scope>
    @keyframes bounce {
        from,
        20%,
        53%,
        80%,
        to {
            -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }

        40%,
        43% {
            -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            -webkit-transform: translate3d(0, -30px, 0);
            transform: translate3d(0, -30px, 0);
        }

        70% {
            -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            -webkit-transform: translate3d(0, -15px, 0);
            transform: translate3d(0, -15px, 0);
        }

        90% {
            -webkit-transform: translate3d(0, -4px, 0);
            transform: translate3d(0, -4px, 0);
        }
    }

    .bounce {
        -webkit-animation-name: bounce;
        animation-name: bounce;
        -webkit-transform-origin: center bottom;
        transform-origin: center bottom;
    }
    .bounce-enter-active {
        animation: bounce 1.5s;
        transition: opacity .5s;
    }
    .bounce-enter{
        opacity: 0;
    }

    @font-face {
        font-family: 'DISPLAY';
        src: url('../../fonts/DISPLAY.ttf') format('truetype');
    }

    .main {
        background: url("../../images/checkin/bg.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .info {
            font-size: 64px;
            text-align: center;
            margin-bottom:20px;
        }
        .detail {
            position: relative;
            width: 1473.07px;
            height: 800px;
            border-radius: 28px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            > img {
                width: 800px;
                height: 371px;
                z-index:101;
            }
            .avatar{
                border:2px solid #FFC555; /*no*/
                box-sizing:border-box;
                top:50px;
                position:absolute;
                border-radius:50%;
                width:270.39px;
                height:270.39px;
                z-index:100;
                overflow: hidden;
                >img{
                    width:100%;
                    height:100%;
                    object-fit: cover;
                }
            }
            .userinfo{
                position: absolute;
                top:32.8vh;
                font-size:40px;
                color:#815202;
                z-index:102;
                height:220px;
                display:flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                >div:nth-child(2){
                    color:#333333;
                    font-weight:blod;
                    font-size:100px;
                }
            }
            .score {

                padding-left:25px;
                text-align: center;
                >img{
                    margin-right:20px;
                    margin-bottom:2px;
                    height:100px;
                    width:25px;
                }
                font-size: 100px;
                > span {
                    font-family: 'DISPLAY';
                }
            }
        }
    }
</style>